<template>
	<main>
		<HeaderTab :title="$t('global.titre_contact_archive_liste')" :return_action="'navigationBack'"/>
		<div id="content">
			<div class="container-fluid">
				<div class="row">
					<div class="col-12">
						<div class="box">
							<CustomTable
								ref="table"
								id_table="contacts_archive_list"
								:busy.sync="table_busy"
								primaryKey="contact_id"
								:hide_if_empty="true"
								:items="filtredContacts"
								:rawColumns="rawColumnNames"
								:externSlotColumns="extern_slot_columns"
							>
								<template v-slot:[`custom-slot-cell(contact_operateur)`]="{ data }">
									<font-awesome-icon class="text-success" v-if="data.contact_operateur" :icon="['fal', 'check-circle']" />
									<font-awesome-icon class="text-danger" v-else :icon="['fal', 'times-circle']" />
								</template>
							</CustomTable>
						</div>

						<ContactForm />
					</div>
				</div>
			</div>
		</div>
	</main>
</template>

<script type="text/javascript">
import Contact from "@/mixins/Contact.js"
import Navigation from "@/mixins/Navigation.js"

export default {
	name: "ContactArchivedList",
	mixins: [Contact, Navigation],
	data () {
		return {
			table_busy: true,
			contacts: [],
			extern_slot_columns: ['contact_operateur'],
			rawColumnNames: ['phones_number'],
			events_tab: {
				'TableAction::goToUnarchiveContact': this.unarchiveContact
			}
		}
	},
	mounted () {
		this.init_component()
	},
	methods: {
		async init_component() {
			this.loadContacts()
		},
		async loadContacts() {
			this.table_busy = true
			this.contacts = await this.getAllArchivedContact()
			this.table_busy = false
		},
		async unarchiveContact(contacts) {
			const ids = contacts.map(c => c.contact_id)
			await this.unarchiveContacts(ids)
			this.loadContacts()
			this.$refs.table.refreshTable()
		}
	},
	computed: {
		filtredContacts: function() {
			let contactsFormated = []
			if(!this.contacts) {
				return []
			}

			const copy_temp = this.deppCloneObj(this.contacts)
			for(let i = 0; i < copy_temp.length; i++) {
				const temp = {...copy_temp[i], ...copy_temp[i].contact}
				temp.phones_number = this.getArrayObjProperty(temp.phones, "phone_combine").join("<br>")
				contactsFormated.push(temp);
			}

			return contactsFormated
		}
	},
	components: {
		HeaderTab: () => import('@/components/HeaderTab'),
		CustomTable: () => import('GroomyRoot/components/Table/CustomTable'),
		ContactForm : () => import('@/components/Contact/ContactForm')
	}
}
</script>
